import { getRemoteSyncState } from "./syncState"

type SyncTrackedRecord = {
  remoteSyncConflictAt?: string
  remoteSyncFailedAt?: string
  remoteSyncedAt?: string
  updatedAt: string
}

export function mergeAuthoritativeRemoteRecords<T extends SyncTrackedRecord>(
  localRecords: readonly T[],
  remoteRecords: readonly T[],
  getId: (record: T) => string,
): T[] {
  const remoteById = new Map(
    remoteRecords.map((record) => [getId(record), record]),
  )
  const merged: T[] = []

  for (const local of localRecords) {
    const recordId = getId(local)
    const remote = remoteById.get(recordId)
    if (!remote) {
      if (getRemoteSyncState(local) !== "synced") {
        merged.push(local)
      }
      continue
    }

    remoteById.delete(recordId)
    if (getRemoteSyncState(local) !== "synced") {
      merged.push(local)
      continue
    }

    if (remote.updatedAt >= local.updatedAt) {
      merged.push(remote)
      continue
    }

    merged.push(local)
  }

  merged.push(...remoteById.values())
  return merged
}
